import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import ProcessorRuleCreate from 'components/ProcessorRule/Create';

const ScreenProcessorRuleCreate = ({ classes, routePaths, target }) => (
  <div className={classes.container}>
    <GridContainer justify="center">
      <GridItem xs={12} sm={9} md={8} lg={7}>
        <ProcessorRuleCreate routePaths={routePaths} target={target} />
      </GridItem>
    </GridContainer>
  </div>
);

ScreenProcessorRuleCreate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  routePaths: PropTypes.shape({}),
  target: PropTypes.string,
};

ScreenProcessorRuleCreate.defaultProps = {
  routePaths: undefined,
  target: undefined,
};

export default withStyles(validationFormsStyle)(ScreenProcessorRuleCreate);
